export const contact = {
  fullName: 'Sarah Gramm Wolf, M. Ed.',
  email: 'garden.heirlooms@gmail.com',
  // email: 'catonthegardenwall@gmail.com',
  displayPhone: '503-360-8086',
  phone: '15033608086',
  location: 'Portland, OR area'
}
